(function () {
  angular.module("akitabox.ui.dialogs.request.deny", [
    "akitabox.core.constants",
    "akitabox.core.services.request",
    "akitabox.core.toast",
  ]);
})();
